import React from 'react';
import EventAdmin from '../../../components/event/admin';

const EventAdminPage = () => {
  return (
    <>
      <EventAdmin />
    </>
  );
};

export default EventAdminPage;
